import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../../CSS/menuSection.css';
import cartebg from '../../images/cartes.png';

const MenuSection = ({
  title,
  showSubtitles = true,
  subtitle1 = "COOPÉRATION",
  subtitle2 = "CONSULATS HONORAIRES",
  backgroundColor = "#f8f9fa",
  textColor = "#0a3764",
  accentColor = "#7d3f98",
  className = "",
  onClick,
  isInteractive = false
}) => {
  const location = useLocation();
  const { t } = useTranslation();
  
  // Déterminer si l'image doit être masquée (page galerie)
  const shouldHideImage = location.pathname === '/galerie';
  
  // Déterminer le titre automatiquement selon la page
  const getTitle = () => {
    if (title) return title; // Si un titre est fourni en prop, l'utiliser
    
    if (location.pathname === '/Consulat-honoraires') {
      return t('menuSection.honoraryConsulates'); // "CONSULATS HONORAIRES" ou "HONORARY CONSULATES"
    }
    
    if (location.pathname === '/Cooperation-bilaterale') {
      return t('menuSection.cooperation'); // "COOPÉRATION" ou "COOPERATION"
    }
    
    return t('menuSection.cooperation'); // Valeur par défaut
  };

  // Fonction pour déterminer si un lien est actif
  const isLinkActive = (linkPath) => {
    if (linkPath === location.pathname) return true;
    
    if (linkPath === '/Cooperation-bilaterale' && location.pathname.startsWith('/Cooperation')) {
      return true;
    }
    
    if (linkPath === '/Consulat-honoraires' && location.pathname.startsWith('/Consulat')) {
      return true;
    }
    
    return false;
  };

  const currentTitle = getTitle();

  return (
    <section
      className={`menu-section ${isInteractive ? 'interactive' : ''} ${className}`}
      style={{
        backgroundColor,
        color: textColor,
        justifyContent: "space-between"
      }}
      onClick={onClick}
      role={isInteractive ? "button" : undefined}
      tabIndex={isInteractive ? 0 : undefined}
    >
      <div>
        <h2
          className="menu-title"
          style={{ color: textColor, marginLeft: "80px" }}
        >
          {currentTitle}
        </h2>

        {/* Conteneur pour les sous-titres en bas */}
        {showSubtitles && (
          <div className="menu-subtitles-container">
            {/* Vos liens commentés */}
          </div>
        )}
      </div>
      
      {/* Afficher l'image seulement si on n'est pas sur la page galerie */}
      {!shouldHideImage && (
        <div>
          <img src={cartebg} style={{}} alt={t('menuSection.mapAlt')} />
        </div>
      )}
    </section>
  );
};

export default MenuSection;